import { openAddCreditCardModal } from '@/redux/modules/modal';
import { PaymentProviders } from '@/enums';
import { useAppDispatch } from '@/redux/hooks';
import { useEffect } from 'react';
import AddCreditCardPageHeaderMeta from './AddCreditCardPageHeaderMeta';
import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import styled from 'styled-components';

const AddCreditCardPage = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(openAddCreditCardModal(PaymentProviders.Payrix));
    }, [dispatch]);

    return (
        <EnsureLoggedInContainer>
            <StyledPageContainer>
                <AddCreditCardPageHeaderMeta />
            </StyledPageContainer>
        </EnsureLoggedInContainer>
    );
};

export default AddCreditCardPage;

const StyledPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
`;
